// extracted by mini-css-extract-plugin
export var orderDetails = "_mg-2";
export var orderImage = "_mg-1";
export var orderMeta = "_mg-3";
export var orderSummary = "_mg-0";
export var rightArrow = "_mg-4";